import React, { useEffect, useState } from "react";
import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from "react-router-dom";
import CssLoader from '../../components/cssloader/CssLoader';
import Link from "../../common/Link";
import Pagination from "../../common/Pagination";
import Sidebar from "../../components/Sidebar";
import { ITeamData } from "../../helpers/interfaces/matchData";
import { ICategoryArticle } from "../../helpers/interfaces/ranking";
import { matchesService } from "../../services/MatchesService";
import Advertising from "../../common/Advertising";
import './Societa.css';

export default function SocietaPage() {
    const { id } = useParams<{ id: string }>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [teamData, setTeamData] = useState<ITeamData | null>(null);
    const [teamArticles, setTeamArticles] = useState<ICategoryArticle[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const pageLimit = 8;
    const pageNeighbours = 5;

    useEffect(() => {
        const fetchTeamData = async () => {
            try {
                const data = await matchesService.getTeamData(id!);
                if (data && typeof data !== "string" && data.id) {
                    setTeamData(data);
                }
            } catch (error) {
                console.error("Error fetching team data: ", error);
            }
        }

        const fetchArticles = async (teamId: string) => {
            try {
                const data = await matchesService.getTeamNews(teamId);

                if (data && typeof data !== "string") {
                    setTeamArticles(data);
                }
            } catch (error) {
                console.error("Error fetching team articles: ", error);
            }
        };

        if (id) {
            (async() => {
                setIsLoading(true);

                await fetchTeamData();
                await fetchArticles(id);

                setIsLoading(false);
            })();
        }
    }, [id]);

    const paginationCards = teamArticles.slice((currentPage - 1) * pageLimit, currentPage * pageLimit);

    return (
        <React.Fragment>
            <div className="contact-tag">{teamData?.nome}</div>
            <Row>
                <Col id="content" xs={12} lg={9}>
                    <div className="team-header">
                        <img src={teamData?.img || 'https://www.calcioa5live.com/img/squadre/VARIE.png'} alt="Team Logo" className="team-logo" />
                    </div>
                    <div className="team-sponsors">
                        <h2>Sponsor</h2>
                        <hr />
                        <div className="sponsor-logos">
                            {teamData?.sponsor && Object.values(teamData.sponsor).map((sponsorImg, index) => (
                                sponsorImg && <img key={index} src={sponsorImg || 'https://www.calcioa5live.com/img/squadre/VARIE.png'} alt={`Sponsor ${index + 1}`} />
                            ))}
                            <img src="https://www.calcioa5live.com/img/squadre/VARIE.png" alt="Sponsor 1" />

                        </div>
                    </div>
                    {/* <div className="team-players">
                        <h2>Giocatori</h2>
                        {paginationPlayers.map((player, index) => (
                            <Card key={`player_${index}`} className="mb-3">
                                <Card.Body>
                                    <Card.Title>{player.nome} {player.cognome}</Card.Title>
                                    <Card.Subtitle className="mb-2 text-muted">{player.ruolo}</Card.Subtitle>
                                    <Card.Text>
                                        Data di Nascita: {player.dataDiNascita || 'N/A'}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        ))}
                        <Pagination
                            totalRecords={teamData?.giocatori.length || 0}
                            pageLimit={pageLimit}
                            pageNeighbours={pageNeighbours}
                            currentPage={currentPage}
                            onPageChanged={(value: any) => { setCurrentPage(value) }}
                        />
                    </div> */}
                    <div className="team-articles">
                        <hr />
                        <Advertising code="banner-cat4" as="div" />
                        <h2 className="mt-2 mb-4">Ultimi articoli sulla società</h2>
                        {paginationCards.map((article, index) => (
                            <Card key={article.id}>
                                {index % 4 === 0 && index !== 0 && (
                                    <Advertising code="banner-cat5" as="div" />
                                )}
                                <Card.Body className="px-2">
                                    <Link href={`/articolo/${article.id}`} title={article.titolo}>
                                        <Row key={article.id}>
                                            <Col className="team-img-container my-auto">
                                                <img src={article.img1 || "https://www.calcioa5live.com/images/noImg.jpg"} className="team-img" alt={article.titolo} />
                                            </Col>
                                            <Col md={8}>
                                                <Card.Title><strong>{article.titolo}</strong></Card.Title>
                                                <Card.Subtitle>{article.strDataPubblicazione} - <span className="author-name">{article.nomeAutore}</span></Card.Subtitle>
                                                <div className="card-text" dangerouslySetInnerHTML={{ __html: article.articolo }} />
                                            </Col>
                                        </Row>
                                    </Link>
                                </Card.Body>
                            </Card>
                        ))}
                        <Pagination
                            totalRecords={teamArticles.length}
                            pageLimit={pageLimit}
                            pageNeighbours={pageNeighbours}
                            currentPage={currentPage}
                            onPageChanged={(value: any) => { setCurrentPage(value) }}
                        />
                    </div>
                </Col>
                <Col id="sidebar" xs={12} lg={3} className="pt-3">
                    <Sidebar />
                </Col>
            </Row>

            <CssLoader active={isLoading} text="Caricamento della società in corso..." />
        </React.Fragment>
    );
}
